import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icon paths (react-leaflet issue with bundlers)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const forestIcon = new L.DivIcon({
  className: '',
  html: '<div style="width:28px;height:28px;background:#1A362D;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.25);border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:13px;">✓</div>',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

function FitBounds({ trades }) {
  const map = useMap();
  useEffect(() => {
    const pts = trades.filter((t) => t.lat && t.lng).map((t) => [t.lat, t.lng]);
    if (pts.length === 0) return;
    if (pts.length === 1) {
      map.setView(pts[0], 12);
    } else {
      map.fitBounds(pts, { padding: [40, 40] });
    }
  }, [trades, map]);
  return null;
}

export default function TradesMap({ trades, onSelect }) {
  const withCoords = (trades || []).filter((t) => t.lat && t.lng);
  const center = withCoords[0] ? [withCoords[0].lat, withCoords[0].lng] : [-31.9505, 115.8605]; // Perth CBD fallback

  return (
    <div className="h-full w-full overflow-hidden border border-[#E5E4E0]" data-testid="trades-map">
      <MapContainer center={center} zoom={11} style={{ height: '100%', width: '100%' }} scrollWheelZoom={true}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        <FitBounds trades={withCoords} />
        {withCoords.map((t) => (
          <Marker key={t.id} position={[t.lat, t.lng]} icon={forestIcon} eventHandlers={{ click: () => onSelect?.(t) }}>
            <Popup>
              <div className="font-semibold">{t.business_name}</div>
              <div className="text-xs opacity-70">{t.suburb}</div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
